
export class AlqBase {    

    public jwt:string
    
    constructor({jwt = ""} = {}) {
        this.jwt = jwt        
    }
}